export const PSEVDO_EXPERIMENT_Q3_2023 = 'newbuilding_psedvo_test_for_kexp_q3_2023';
export const LAYOUT_EXPERIMENT = 'newbuiding_layouts_on_cardJK';
